// JS Dependencies: Popper, Bootstrap & JQuery
import '@popperjs/core';
const { initOnLoad } = await import('./shared_dependecies');
window.onload = async (event) => {
    await initOnLoad();
};
